import React from 'react';
import PhotoCard from '../PhotoCard/PhotoCard';
import { DeckContainer } from './PhotoDeck.styles';

const PhotoDeck = ({ photos }) => {
  if (!photos || photos.length === 0) return null;

  // A repeating pattern to assign different spans to the photos
  const bentoPattern = [
    'large',  // Spans 2x2
    'normal', // Spans 1x1
    'normal', // Spans 1x1
    'wide',   // Spans 2x1
    'normal', // Spans 1x1
    'normal', // Spans 1x1
    'wide'    // Spans 2x1
  ];

  return (
    <DeckContainer>
      {photos.map((photo, index) => {
        // Map the current index to the pattern array
        const variant = bentoPattern[index % bentoPattern.length];
        
        return (
          <PhotoCard 
            key={index} 
            photo={photo} 
            index={index} 
            variant={variant}
          />
        );
      })}
    </DeckContainer>
  );
};

export default PhotoDeck;